import { Globe, Wallet } from "lucide-react";
import { bsc } from "wagmi/chains";
import { useAccount, useConnect, useDisconnect, useSwitchChain } from "wagmi";
import { assets } from "../assets";

function truncate(address: string): string {
  if (address.length <= 10) return address;
  return `${address.slice(0, 6)}…${address.slice(-4)}`;
}

export function BrandHeader() {
  const { address, isConnected, chainId } = useAccount();
  const { connectors, connect, isPending: connectPending } = useConnect();
  const { disconnect } = useDisconnect();
  const { switchChain } = useSwitchChain();

  const wrongNetwork = chainId !== undefined && chainId !== bsc.id;
  const injected = connectors[0];
  const noConnector = !injected;

  const chipClass = wrongNetwork
    ? "bg-ember/15 text-ember border-ember/30"
    : "bg-wing/10 text-wing border-wing/30";

  const chipLabel = wrongNetwork ? "Wrong network · Switch" : "BSC";

  const handleChipClick = () => {
    if (wrongNetwork) switchChain({ chainId: bsc.id });
  };

  const handleWallet = () => {
    if (isConnected) {
      disconnect();
    } else if (injected) {
      connect({ connector: injected });
    }
  };

  return (
    <header className="flex items-center justify-between gap-4 py-2">
      <div className="flex items-center gap-3">
        <div className="relative">
          <span className="absolute -inset-1 rounded-full bg-wing/20 blur-md opacity-60" aria-hidden />
          <img
            src={assets.fengniaoMark}
            alt="蜂鸟"
            width={40}
            height={40}
            className="relative w-10 h-10 rounded-full ring-1 ring-wing/30 object-cover"
          />
        </div>
        <div className="flex flex-col leading-tight">
          <span className="font-semibold text-lg text-ink">蜂鸟</span>
          <span className="text-[10px] font-mono uppercase tracking-[0.2em] text-ink-dim">
            FENGNIAO
          </span>
        </div>
      </div>

      <div className="flex items-center gap-2">
        <button
          type="button"
          onClick={handleChipClick}
          disabled={!wrongNetwork}
          className={`inline-flex items-center gap-1.5 rounded-chip border px-2.5 py-1.5 text-xs font-medium transition duration-150 ${chipClass} ${wrongNetwork ? "hover:brightness-125 cursor-pointer" : "cursor-default"}`}
        >
          <Globe className="w-3.5 h-3.5" strokeWidth={1.75} aria-hidden />
          <span>{chipLabel}</span>
        </button>

        <button
          type="button"
          onClick={handleWallet}
          disabled={noConnector || connectPending}
          title={noConnector ? "未检测到钱包" : undefined}
          className="btn-ghost inline-flex items-center gap-1.5 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <Wallet className="w-3.5 h-3.5" strokeWidth={1.75} aria-hidden />
          <span className="font-mono">
            {isConnected && address ? truncate(address) : "连接钱包"}
          </span>
        </button>
      </div>
    </header>
  );
}
